import { ColDef } from 'ag-grid-community';
import dayjs from 'dayjs';

import { TTenantSubscription } from '@/backoffice/features/tenants/hooks/use-tenant-subscriptions/use-tenant-subscriptions.types';
import { SUBSCRIPTION_STATUS_URGENCY } from '@/backoffice/features/tenants/utils/subscription-status.const';
import { TSubscriptionStatus } from '@/backoffice/features/tenants/utils/subscription-status.types';
import { EXPIRATION_WARNING_DAYS } from '@/shared/features/billing/components/subscription-status-warning-chip/subscription-status-warning-chip.const';

// Same rules as the subscription page: a cancellation outranks an expiration.
export const getSubscriptionStatus = ({
  term,
}: TTenantSubscription): TSubscriptionStatus => {
  if (term.cancellationTs) return 'cancelled';
  if (!term.expirationTs) return 'active';
  if (term.expirationTs * 1000 <= Date.now()) return 'expired';

  const daysLeft = dayjs.unix(term.expirationTs).diff(dayjs(), 'day');
  return daysLeft <= EXPIRATION_WARNING_DAYS ? 'expiringSoon' : 'active';
};

// Tenants without a subscription stay at the bottom in both directions.
export const compareSubscriptionStatus: NonNullable<ColDef['comparator']> = (
  statusA: TSubscriptionStatus | undefined,
  statusB: TSubscriptionStatus | undefined,
  _nodeA,
  _nodeB,
  isDescending,
) => {
  if (!statusA && !statusB) return 0;
  if (!statusA) return isDescending ? -1 : 1;
  if (!statusB) return isDescending ? 1 : -1;
  return (
    SUBSCRIPTION_STATUS_URGENCY[statusA] - SUBSCRIPTION_STATUS_URGENCY[statusB]
  );
};
